import type { IconProps } from '../types/IconProps.ts';
export const MailPlus: IconProps = {
    name: 'MailPlus',
    children: [
        `<path d="M12 20H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h16a2 2 0 0 1 2 2v6M19 16v6M16 19h6" />`,
        `<path d="m2 8 9.1 4.55a2 2 0 0 0 1.8 0L22 8" />`,
    ]
};